export default __webpack_public_path__ + "static/artwork2-a93f41e10fc94292da489d4bae44227e.webp";